import React, { Component } from "react";
import { BigScreenBody, mapDataList, meteoDataList, autoPlayTypeList } from "./style";
import { colorPalette, chartStyle, pieChartColor } from "../../color-palette";
import { ScreenCard, PieChart, McLineChart, DoubleBarChart, McBarChart, GaugeAntd, CropAreaCard, WeatherChart, RadioSelectSimple,
  RadioSelectSimpleTo } from "../../components";
import cropAreaBg from "./images/23@2x.png";
import cropAreaBg2 from "./images/24@2x.png";
import { MapGL, MapPosition, MapGLProps } from "@gago-react-gl/gago-react-gl";
import { zcMapDefault, ZengChengMapLayer } from "../../containers/map-layer";
import BigScreenProvider, { forecastShortItable } from "../../network/providers/big-screen.provider";
import { message } from "antd";
import { LandTypeLayer, RiceTypeLayer, TmaxLayer, getNextSevenDaysList, TminLayer, ApcpLayer } from "./map-layer";
import { ITable, Timeline7, Icon } from "@gago/frame";
import { ResourceLabelStatus, ForecastDay } from "../../models/big-screen";
import moment from "moment";
import turfBbox from "@turf/bbox";
// tslint:disable:ter-max-len naming-convention jsx-no-multiline-js
interface Bstate {
  /** 行政code */
  townCode: string;
  /** 定义map实例 */
  mapBaseGL: mapboxgl.Map;
  /** 地图图层类型选择 */
  mapTypeSelect: string;
  /** 气象预报类型选择 */
  meteoTypeSelect: string;
  /** 资源概况数据 */
  resourceType: ITable<1, 1> | null;
  /** 指定获取基础资源五年数据 耕地面积 */
  resourceHistoryArable: ITable<2, 1> | null;
  /** 指定获取基础资源五年数据 水稻面积 */
  resourceHistoryRice: ITable<2, 1> | null;
  /** 指定资源地图上方标签数据 */
  resourceLabel: ResourceLabelStatus | null;
  /** 农业气象服务 */
  forecastShort: ForecastDay[];
  /** 气候趋势分析，积温 */
  climateTrendAt: ITable<1, 5> | null;
  /** 气候趋势分析，降水 */
  climateTrendApcp: ITable<1, 5> | null;
  /** 历史气象柱状图 */
  weatherHistory: ITable<1, 2> | null;
  /** 气象预报时间轴选择 */
  selectDate: string;
  /** 图层自动播放状态 */
  playCarousel: boolean;
}

/**
 * 大屏页面开发
 * @author 马俊峰
 * @date 2020-07-27
 * @export
 * @class BigScreen
 * @extends {Component<{}, Bstate>}
 */
export class BigScreen extends Component<{}, Bstate> {
  /** 定时器实例 */
  clearCarousel: number | null = null;
  /** 地图交互图层事件 */
  baseMapStatus = true;
  state: Bstate = {
    townCode: "",
    mapBaseGL: undefined as unknown as mapboxgl.Map,
    mapTypeSelect: "资源分布",
    meteoTypeSelect: "最高温",
    resourceType: null,
    resourceHistoryArable: null,
    resourceHistoryRice: null,
    resourceLabel: null,
    forecastShort: [],
    climateTrendAt: null,
    climateTrendApcp: null,
    weatherHistory: null,
    selectDate: moment().format("YYYY-MM-DD"),
    playCarousel: false,
  };
  /** 城镇加载数据 */
  loadCodeData = async () => {
    const param = { code: this.state.townCode === "" ? undefined : this.state.townCode };
    const param1 = { code: this.state.townCode === "" ? undefined : this.state.townCode, type: "arable" };
    const param2 = { code: this.state.townCode === "" ? undefined : this.state.townCode, type: "rice" };
    const resourceType = await BigScreenProvider.getResourceType(param).catch(err => { message.info("资源概况数据获取失败！", 1); return null; });
    const resourceHistoryArable = await BigScreenProvider.getResourceHistory(param1).catch(err => { message.info("耕地面积数据获取失败！", 1); return null; });
    const resourceHistoryRice = await BigScreenProvider.getResourceHistory(param2).catch(err => { message.info("水稻面积数据获取失败！", 1); return null; });
    const resourceLabel = await BigScreenProvider.getResourceLabel(param).catch(err => { message.info("作物面积数据获取失败！", 1); return null; });
    const forecastShort = await BigScreenProvider.getForecastShort(param).catch(err => { message.info("气象服务数据获取失败！", 1); return []; });
    const climateTrendAt = await BigScreenProvider.getClimateTrendAt(param).catch(err => { message.info("积温获取失败！", 1); return null; });
    const climateTrendApcp = await BigScreenProvider.getClimateTrendApcp(param).catch(err => { message.info("降水获取失败！", 1); return null; });
    const weatherHistory = await BigScreenProvider.getWeatherHistory(param).catch(err => { message.info("历史气象数据获取失败！", 1); return null; });
    this.setState({ resourceType, resourceHistoryArable, resourceHistoryRice, resourceLabel, forecastShort, climateTrendAt, climateTrendApcp, weatherHistory });
  }
  componentDidMount() {
    this.loadCodeData();
  }
  /** 地图加载完毕获取实例 */
  mapOnLoad: MapGLProps["onLoad"] = (map) => {
    this.setState({ mapBaseGL: map.target });
  }
  // tslint:disable-next-line:cyclomatic-complexity
  render() {
    const datalist = getNextSevenDaysList();
    const { townCode, mapTypeSelect, resourceType, resourceHistoryArable, resourceHistoryRice, resourceLabel, forecastShort, climateTrendAt, climateTrendApcp, weatherHistory,
            playCarousel } = this.state;
    return(
      <BigScreenBody colorPalette={colorPalette}>
        <div className="header-box" />
        <div className="screen-body">
          <div className="asider-left">
            <ScreenCard className="left-chart" colorPalette={colorPalette} title="资源概况">
              {resourceType && <PieChart
                legendShowPercent={false}
                chartData={resourceType}
                chartStyle={chartStyle}
                colorPalette={pieChartColor}
              />}
            </ScreenCard>
            <ScreenCard className="left-chart" colorPalette={colorPalette} title="耕地面积趋势">
              {resourceHistoryArable && <McLineChart
                chartData={resourceHistoryArable}
                showSmooth={false}
                showSymbol={false}
                chartStyle={chartStyle}
                colorPalette={{ ...colorPalette, subColor: ["#00fdff", "#1d9bff", "#ffd164", "#ff7b2f", "#ff51a2", "#ff7b2f"] }}
              />}
            </ScreenCard>
            <ScreenCard className="left-chart" colorPalette={colorPalette} title="水稻面积趋势">
              {resourceHistoryRice && <McBarChart
                chartData={resourceHistoryRice}
                chartStyle={chartStyle}
                colorPalette={{ ...colorPalette, subColor: ["#ff7b2f", "#ff51a2", "#ff7b2f"] }}
              />}
            </ScreenCard>
          </div>
          <div className="content-middle">
            <div className="cm-top-box">
              <CropAreaCard
                title="耕地面积"
                className="cmt-chart"
                data={resourceLabel && resourceLabel.arable || 0}
                suffix="万亩"
                colorPalette={colorPalette}
                style={{ backgroundImage: `url(${cropAreaBg2})` }}
              />
              <CropAreaCard
                title="水稻面积"
                className="cmt-chart"
                data={resourceLabel && resourceLabel.rice || 0}
                suffix="万亩"
                colorPalette={colorPalette}
                style={{ backgroundImage: `url(${cropAreaBg})` }}
              />
            </div>
            <div className="cm-map-box">
              <RadioSelectSimple
                className="cmb-select"
                colorPalette={colorPalette}
                data={mapDataList}
                value={mapTypeSelect}
                defaultValue="资源分布"
                backSelectChange={this.mapTypeChange}
              />
              {mapTypeSelect === "气象预报" && <RadioSelectSimpleTo
                className="cmb-select-second"
                colorPalette={colorPalette}
                data={meteoDataList}
                defaultValue="最高温"
                backSelectChange={this.meteoTypeChange}
              />}
              <div className={`auto-button ${playCarousel ? "b-active" : ""}`} tabIndex={0} onBlur={this.stopAutoPlay} onClick={this.autoPlayCarousel} />
              {townCode !== "" && <div className="back-box" onClick={this.mapBackClick}>
                <Icon>rollback</Icon>
                <span className="back-value">返回</span>
              </div>}
              <MapGL {...zcMapDefault} onLoad={this.mapOnLoad}>
                <MapPosition bbox={[[113.55, 23.05], [114, 23.65]]} moveMethod="jumpTo" />
                {this.mapBaseLayerRender()}
                <ZengChengMapLayer
                  id="zengcheng_outline_layer"
                  townCode={townCode}
                  beforeLayer={["map_type_layer"]}
                  callbackLayer={this.shanDongMapLayerClick}
                />
              </MapGL>
              {mapTypeSelect === "气象预报" && <div className="timeline-box">
                <Timeline7
                  interval={4000}
                  loop="all"
                  data={datalist}
                  colorPalette={colorPalette}
                  onChange={this.timelineChange}
                />
              </div>}
            </div>
          </div>
          <div className="asider-left">
            <ScreenCard className="left-chart right-top-chart" colorPalette={colorPalette} title="农业气象服务">
              <div className="weather-forecast"> {forecastShort.length > 0 ? forecastShort[0].warning.join("、") : "暂无气象风险，请时刻关注天气预报。"}</div>
              <WeatherChart
                className="forecast-chart"
                colorPalette={colorPalette}
                chartData={forecastShortItable(forecastShort)}
              />
            </ScreenCard>
            <ScreenCard className="left-chart right-chart" colorPalette={colorPalette} title="气象趋势分析">
              <div className="gauge-antd-border">
                {climateTrendApcp && <GaugeAntd
                  colorPalette={{ ...colorPalette, subColor: ["rgba(130, 224, 255, 0.45)", "#82e0ff"] }}
                  className="gauge-antd-box"
                  chartData={climateTrendApcp}
                />}
                {climateTrendAt && <GaugeAntd
                  colorPalette={{ ...colorPalette, subColor: ["rgba(255, 146, 22, 0.45)", "#ff9216"] }}
                  className="gauge-antd-box"
                  chartData={climateTrendAt}
                />}
              </div>
            </ScreenCard>
            <ScreenCard className="left-chart right-chart" colorPalette={colorPalette} title="历史气象">
              {weatherHistory && <DoubleBarChart
                chartData={weatherHistory}
                chartStyle={chartStyle}
                colorPalette={{ ...colorPalette, subColor: ["#00fdff", "#ff7b2f"] }}
              />}
            </ScreenCard>
          </div>
        </div>
      </BigScreenBody>
    );
  }
  /** 地图底层图层事件 */
  mapBackClick = () => {
    const { mapBaseGL } = this.state;
    if (mapBaseGL && mapBaseGL.fitBounds) {
      mapBaseGL.fitBounds([[113.55, 23.05], [114, 23.65]]);
    }
    this.baseMapStatus = true;
    this.setState({ townCode: "" }, this.loadCodeData);
  }
  /** 增城区农事地块点击事件 */
  shanDongMapLayerClick = (properties: any, geometry: any) => {
    this.baseMapStatus = false;
    const { town, town_code } = properties;
    const { mapBaseGL } = this.state;
    const bbox = turfBbox(geometry) as unknown as mapboxgl.LngLatBoundsLike;
    if (mapBaseGL && mapBaseGL.fitBounds) {
      mapBaseGL.fitBounds(bbox);
    }
    this.setState({ townCode: town_code }, this.loadCodeData);
  }
  /** 地图类型返回数据 */
  mapTypeChange = (type: string) => {
    this.setState({ mapTypeSelect: type, meteoTypeSelect: "最高温" });
  }
  /** 气象预报类型返回数据 */
  meteoTypeChange = (type: string) => {
    this.setState({ meteoTypeSelect: type });
  }

  /** 自动播放点击事件， */
  autoPlayCarousel = () => {
    const { playCarousel } = this.state;
    this.setState({ playCarousel: !playCarousel }, this.startPlayCarousel);
  }
  /** 开启定时逻辑 */
  startPlayCarousel = () => {
    const { playCarousel } = this.state;
    this.clearCarousel && clearInterval(this.clearCarousel);
    // tslint:disable-next-line:early-exit
    if (playCarousel) {
      this.clearCarousel = window.setInterval(() => {
        const { mapTypeSelect } = this.state;
        let currentIndex = 0;
        currentIndex = autoPlayTypeList.indexOf(mapTypeSelect);
        currentIndex++;
        if (currentIndex >= 3) { currentIndex = 0; }
        this.mapTypeChange(autoPlayTypeList[currentIndex]);
      }, 6000);
    }
  }
  /** 丢失焦点执行停止播放事件 */
  stopAutoPlay = () => {
    this.setState({ playCarousel: false });
    this.clearCarousel && clearInterval(this.clearCarousel);
  }

  /** 时间轴改变事件 */
  timelineChange = (date: string) => {
    if (date === this.state.selectDate) { return; }
    this.setState({ selectDate: date });
  }
  /** 地图图层逻辑dom输出 */
  mapBaseLayerRender = () => {
    const { mapTypeSelect, meteoTypeSelect, selectDate } = this.state;
    if (mapTypeSelect === "资源分布") { return <LandTypeLayer />; }
    if (mapTypeSelect === "水稻分布") { return <RiceTypeLayer />; }
    // tslint:disable:no-collapsible-if
    if (mapTypeSelect === "气象预报") {
      if (meteoTypeSelect === "最高温") { return <TmaxLayer date={selectDate} />; }
      if (meteoTypeSelect === "最低温") { return <TminLayer date={selectDate} />; }
      if (meteoTypeSelect === "降水") { return <ApcpLayer date={selectDate} />; }
    }
  }
}
